module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "14",
      "height": "10",
      "viewBox": "0 0 14 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.6436 0.427734H12.3044C12.2133 0.427734 12.1276 0.472377 12.074 0.545592L7.00078 7.53845L1.92757 0.545592C1.874 0.472377 1.78828 0.427734 1.69721 0.427734H0.357927C0.241856 0.427734 0.173998 0.559877 0.241856 0.65452L6.53828 9.33488C6.76686 9.64916 7.23471 9.64916 7.4615 9.33488L13.7579 0.65452C13.8276 0.559877 13.7597 0.427734 13.6436 0.427734Z",
      "fill": _vm.color
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a0265ef4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0265ef4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/Down.vue
// module id = 1518
// module chunks = 159